import { render, staticRenderFns } from "./SystemMessageBirthday.vue?vue&type=template&id=0c7a7e3a&scoped=true&"
import script from "./SystemMessageBirthday.vue?vue&type=script&lang=js&"
export * from "./SystemMessageBirthday.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageBirthday.vue?vue&type=style&index=0&id=0c7a7e3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7a7e3a",
  null
  
)

export default component.exports